// colorPresets.js :contentReference[oaicite:0]{index=0}
export const COLOR_PRESETS = {
  professional: {
    primary: {
      bg: "bg-blue-600",
      hover: "hover:bg-blue-700",
      border: "border-blue-600",
      text: "text-blue-600",
      lightBg: "bg-blue-50",
      focusRing: "focus:ring-blue-500"
    },
    secondary: {
      bg: "bg-slate-600",
      hover: "hover:bg-slate-700",
      border: "border-slate-600",
      text: "text-slate-600",
      lightBg: "bg-slate-50"
    },
    neutral: {
      100: "bg-slate-100",
      200: "bg-slate-200",
      300: "bg-slate-300",
      400: "bg-slate-400",
      500: "bg-slate-500",
      800: "bg-slate-800",
      text: "text-slate-800",
      lightText: "text-slate-500",
      border: "border-slate-200",
      hover: "hover:bg-slate-50"
    },
    state: {
      success: {
        bg: "bg-emerald-600",
        hover: "hover:bg-emerald-700"
      },
      danger: {
        bg: "bg-red-600",
        hover: "hover:bg-red-700",
        text: "text-red-600",
        border: "border-red-600"
      },
      warning: {
        bg: "bg-amber-500",
        hover: "hover:bg-amber-600"
      },
      libero: {
        bg: "bg-yellow-100",
        border: "border-yellow-400",
        text: "text-yellow-800",
        hover: "hover:bg-yellow-200"
      }
    },
    typography: {
      header: {
        primary: "text-2xl lg:text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-700 bg-clip-text text-transparent",
        secondary: "text-xl lg:text-2xl font-semibold text-blue-700",
        tertiary: "text-lg font-semibold text-blue-600"
      }
    },
    // Team colors derived from primary/secondary values
    teamA: {
      bg: "bg-blue-50",
      border: "border-blue-600",
      text: "text-blue-600",
      hover: "hover:bg-blue-100",
      dot: "bg-blue-500",
      button: "bg-blue-600 hover:bg-blue-700"
    },
    teamB: {
      bg: "bg-slate-50",
      border: "border-slate-600",
      text: "text-slate-600",
      hover: "hover:bg-slate-100",
      dot: "bg-slate-500",
      button: "bg-slate-600 hover:bg-slate-700"
    },
    // Centralized Button Styles
    buttons: {
      primary: "px-4 py-2 font-semibold rounded-md shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-blue-600 hover:bg-blue-700 text-blue-600 focus:ring-blue-500",
      secondary: "px-4 py-2 font-semibold rounded-md border transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-slate-600 hover:bg-slate-700 text-slate-600 border-slate-600",
      tertiary: "px-3 py-1 text-sm rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 border border-slate-200 text-slate-800 hover:bg-slate-50"
    }
  },
  tealCoral: {
    primary: {
      bg: "bg-teal-600",
      hover: "hover:bg-teal-700",
      border: "border-teal-600",
      text: "text-teal-600",
      lightBg: "bg-teal-50",
      focusRing: "focus:ring-teal-500"
    },
    secondary: {
      bg: "bg-orange-600",
      hover: "hover:bg-orange-700",
      border: "border-orange-600",
      text: "text-orange-600",
      lightBg: "bg-orange-50"
    },
    neutral: {
      100: "bg-neutral-100",
      200: "bg-neutral-200",
      300: "bg-neutral-300",
      400: "bg-neutral-400",
      500: "bg-neutral-500",
      800: "bg-neutral-800",
      text: "text-neutral-800",
      lightText: "text-neutral-500",
      border: "border-neutral-200",
      hover: "hover:bg-neutral-50"
    },
    state: {
      success: {
        bg: "bg-green-600",
        hover: "hover:bg-green-700"
      },
      danger: {
        bg: "bg-red-600",
        hover: "hover:bg-red-700",
        text: "text-red-600",
        border: "border-red-600"
      },
      warning: {
        bg: "bg-yellow-500",
        hover: "hover:bg-yellow-600"
      },
      libero: {
        bg: "bg-white",
        border: "border-yellow-400",
        text: "text-yellow-800",
        hover: "hover:bg-yellow-200"
      }
    },
    typography: {
      header: {
        primary: "text-2xl lg:text-3xl font-bold bg-gradient-to-r from-teal-600 to-teal-800 bg-clip-text text-transparent",
        secondary: "text-xl lg:text-2xl font-semibold text-teal-700",
        tertiary: "text-lg font-semibold text-teal-600"
      }
    },
    teamA: {
      bg: "bg-teal-50",
      border: "border-teal-400",
      text: "text-teal-800",
      hover: "hover:bg-teal-100",
      dot: "bg-teal-500",
      button: "bg-teal-600 hover:bg-teal-700"
    },
    teamB: {
      bg: "bg-orange-50",
      border: "border-orange-400",
      text: "text-orange-800",
      hover: "hover:bg-orange-100",
      dot: "bg-orange-500",
      button: "bg-orange-600 hover:bg-orange-700"
    },
    buttons: {
      primary: "px-4 py-2 font-semibold rounded-md shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-teal-600 hover:bg-teal-700 text-white focus:ring-teal-500",
      secondary: "px-4 py-2 font-semibold rounded-md border transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-white hover:bg-orange-700 text-black border-orange-600",
      tertiary: "px-3 py-1 text-sm rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 border border-neutral-200 text-neutral-800 hover:bg-neutral-50"
    }
  },
  indigoAmber: {
    primary: {
      bg: "bg-indigo-600",
      hover: "hover:bg-indigo-700",
      border: "border-indigo-600",
      text: "text-indigo-600",
      lightBg: "bg-indigo-50",
      focusRing: "focus:ring-indigo-500"
    },
    secondary: {
      bg: "bg-amber-600",
      hover: "hover:bg-amber-700",
      border: "border-amber-600",
      text: "text-amber-600",
      lightBg: "bg-amber-50"
    },
    neutral: {
      100: "bg-gray-100",
      200: "bg-gray-200",
      300: "bg-gray-300",
      400: "bg-gray-400",
      500: "bg-gray-500",
      800: "bg-gray-800",
      text: "text-gray-800",
      lightText: "text-gray-500",
      border: "border-gray-200",
      hover: "hover:bg-gray-50"
    },
    state: {
      success: {
        bg: "bg-green-600",
        hover: "hover:bg-green-700"
      },
      danger: {
        bg: "bg-red-600",
        hover: "hover:bg-red-700",
        text: "text-red-600",
        border: "border-red-600"
      },
      warning: {
        bg: "bg-yellow-500",
        hover: "hover:bg-yellow-600"
      },
      libero: {
        bg: "bg-yellow-100",
        border: "border-yellow-400",
        text: "text-yellow-800",
        hover: "hover:bg-yellow-200"
      }
    },
    typography: {
      header: {
        primary: "text-2xl lg:text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-700 bg-clip-text text-transparent",
        secondary: "text-xl lg:text-2xl font-semibold text-indigo-700",
        tertiary: "text-lg font-semibold text-indigo-600"
      }
    },
    teamA: {
      bg: "bg-indigo-50",
      border: "border-indigo-400",
      text: "text-indigo-700",
      hover: "hover:bg-indigo-100",
      dot: "bg-indigo-500",
      button: "bg-indigo-600 hover:bg-indigo-700"
    },
    teamB: {
      bg: "bg-amber-50",
      border: "border-amber-400",
      text: "text-amber-700",
      hover: "hover:bg-amber-100",
      dot: "bg-amber-500",
      button: "bg-amber-600 hover:bg-amber-700"
    },
    buttons: {
      primary: "px-4 py-2 font-semibold rounded-md shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-indigo-600 hover:bg-indigo-700 text-indigo-600 focus:ring-indigo-500",
      secondary: "px-4 py-2 font-semibold rounded-md border transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-amber-600 hover:bg-amber-700 text-amber-600 border-amber-600",
      tertiary: "px-3 py-1 text-sm rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 border border-gray-200 text-gray-800 hover:bg-gray-50"
    }
  },
  emeraldFuchsia: {
    primary: {
      bg: "bg-emerald-600",
      hover: "hover:bg-emerald-700",
      border: "border-emerald-600",
      text: "text-emerald-600",
      lightBg: "bg-emerald-50",
      focusRing: "focus:ring-emerald-500"
    },
    secondary: {
      bg: "bg-fuchsia-600",
      hover: "hover:bg-fuchsia-700",
      border: "border-fuchsia-600",
      text: "text-fuchsia-600",
      lightBg: "bg-fuchsia-50"
    },
    neutral: {
      100: "bg-gray-100",
      200: "bg-gray-200",
      300: "bg-gray-300",
      400: "bg-gray-400",
      500: "bg-gray-500",
      800: "bg-gray-800",
      text: "text-gray-800",
      lightText: "text-gray-500",
      border: "border-gray-200",
      hover: "hover:bg-gray-50"
    },
    state: {
      success: {
        bg: "bg-green-600",
        hover: "hover:bg-green-700"
      },
      danger: {
        bg: "bg-red-600",
        hover: "hover:bg-red-700",
        text: "text-red-600",
        border: "border-red-600"
      },
      warning: {
        bg: "bg-yellow-500",
        hover: "hover:bg-yellow-600"
      },
      libero: {
        bg: "bg-yellow-100",
        border: "border-yellow-400",
        text: "text-yellow-800",
        hover: "hover:bg-yellow-200"
      }
    },
    typography: {
      header: {
        primary: "text-2xl lg:text-3xl font-bold bg-gradient-to-r from-emerald-600 to-green-700 bg-clip-text text-transparent",
        secondary: "text-xl lg:text-2xl font-semibold text-emerald-700",
        tertiary: "text-lg font-semibold text-emerald-600"
      }
    },
    teamA: {
      bg: "bg-emerald-50",
      border: "border-emerald-400",
      text: "text-emerald-800",
      hover: "hover:bg-emerald-100",
      dot: "bg-emerald-500",
      button: "bg-emerald-600 hover:bg-emerald-700"
    },
    teamB: {
      bg: "bg-fuchsia-50",
      border: "border-fuchsia-400",
      text: "text-fuchsia-800",
      hover: "hover:bg-fuchsia-100",
      dot: "bg-fuchsia-500",
      button: "bg-fuchsia-600 hover:bg-fuchsia-700"
    },
    buttons: {
      primary: "px-4 py-2 font-semibold rounded-md shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-emerald-600 hover:bg-emerald-700 text-emerald-600 focus:ring-emerald-500",
      secondary: "px-4 py-2 font-semibold rounded-md border transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 bg-fuchsia-600 hover:bg-fuchsia-700 text-fuchsia-600 border-fuchsia-600",
      tertiary: "px-3 py-1 text-sm rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 border border-gray-200 text-gray-800 hover:bg-gray-50"
    }
  },
  // ... other themes follow the same pattern (e.g. purpleRose, skyAmber, wedding, coffee, retro, etc.)
};

export const getTheme = (themeName = "professional") => {
  return COLOR_PRESETS[themeName] || COLOR_PRESETS.professional;
};
